import { render } from "./MatchView.vue?vue&type=template&id=7b39758c&ts=true"
import script from "./MatchView.vue?vue&type=script&lang=ts"
export * from "./MatchView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Matches/MatchView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b39758c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b39758c', __exports__)) {
    api.reload('7b39758c', __exports__)
  }
  
  module.hot.accept("./MatchView.vue?vue&type=template&id=7b39758c&ts=true", () => {
    api.rerender('7b39758c', render)
  })

}


export default __exports__